<template v-slot:top>
  <div class="pt-7 px-5">
    <div class="pa-5">
      <v-row no-gutters>
        <v-col :cols="4">
          <v-select
            v-model="questSysId"
            :items="surveys"
            item-text="questTitle"
            item-value="questSysId"
            menu-props="auto"
            :label="!questSysId ? '尚未選擇問卷' : '已選擇問卷'"
            outlined
          ></v-select>
        </v-col>
        <v-col :cols="4">
          <v-btn @click="query" large class="ml-2 mt-1" color="primary">查詢</v-btn>
        </v-col>
      </v-row>

      <ExportAll></ExportAll>
      

      
    </div>
    <!-- 警示文字 -->
    <v-alert
      v-for="(alert, idx) in alerts"
      :key="idx"
      v-model="alert.show"
      :type="alert.type"
      dense
      dismissible
    >
      {{ alert.msg }}
    </v-alert>

    <chart
      v-for="(QuestM, idx) in QuestM"
      :key="idx"
      :QuestM="QuestM"
      :QuestD="QuestD"
      :serial="idx + 1"
      class="mb-2"
    />
  </div>
</template>

<script>
import ChartRouter from '../components/ChartRouter'
import ExportAll from '../components/ExportAll'

export default {
  components: {
    chart: ChartRouter,
    ExportAll,
  },
  created() {
    this.ques_template = Object.values(this.$store.state.QType)    
  }, 
  mounted() {
    let url = this.$store.state.api + '/Q02010/GetM'
    window.console.log(url)
    this.axios(url).then((res) => {
      this.surveys = res.data.questMList
    });
  },
  data() {
    return {
      questSysId: null,
      ques_template: [],
      surveys: [],
      alerts: [],
      QuestM: [],
      QuestD: [],
    }
  },
  methods: { 
    query() {      
      if (!this.questSysId) {
        this.addAlert('warning', '查詢時沒有提供問卷主檔Id')
        return
      }

      // reset exporting array
      this.$store.state.charts = []
      this.QuestM = []
      this.QuestD = []

      let url = this.$store.state.api + '/Q03010/QueryQuestData'
      let data = Object.assign({ questSysId: this.questSysId })
      this.axios.post(url, this.qs.stringify(data)).then((res) => {
        this.QuestM.splice(0)
        this.QuestD.splice(0)
        if (res.data.resultCode == '10') {
          var rows = res.data.rows
          var details = res.data.details
          window.console.log(rows)
          window.console.log(details)
          if (res.data.details.length == 0) {
            this.addAlert('warning', '此問卷尚無回復明細或題型均無統計圖')
            return
          }
          for (let i = 0; i < res.data.rows.length; i++) {
            var row = rows[i]
            this.QuestM.push(row)
          }

          for (let i = 0; i < res.data.details.length; i++) {
            var detail = details[i]
            this.QuestD.push(detail)
          }
        } else {
          alert(res.data.error)
        }
      })
    },
    addAlert(type, msg, timeout) {
      // 建立一個 alert 物件並推到 alerts
      let alert = { msg: msg, type: type, show: true, value: 0 }
      this.alerts.push(alert)

      // 檢查 timeout 參數，如果沒有就設為 1.2 秒
      if (timeout === undefined || timeout === null) {
        timeout = 1500
      }
      setTimeout(function () {
        alert.show = false
      }, timeout)
    },
  },
}
</script>

<style lang="scss" scoped>
/*
$chartWidth: 600px;
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  background: rgba(37, 37, 37, 0.84);
}

#app {
}

h1 {
  font-family: Dosis, 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif;
  padding: 2em 0 1em;
  text-align: center;
  a {
    text-decoration: none;
    color: #ccc;
  }
}

h1,
h3 {
  color: #ccc;
  font-weight: 300;
  p {
    font-size: 14px;
    margin: 5px;
  }
}

.charts {
  width: $chartWidth;
  margin: 0 auto;
  padding: 2em 0;
  text-align: center;
  h3 {
    text-align: center;
    margin: 0;
  }
  button {
    padding: 5px 20px;
    background: #fff;
    -webkit-appearance: none;
    border: 1px solid #c5c5c5;
    border-radius: 5px;
    outline: none;
    &:hover {
      background: lightgray;
      color: #333;
    }
  }
}

.highcharts {
  display: inline-block;
  margin: 2em auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 0 45px rgba(0, 0, 0, 0.2);
  padding: 1.5em 0em;
  background: #fff;
}
.nav {
  padding: 15px 0 0;
  margin: 0 auto;
  text-align: center;
  max-width: 600px;
  a {
    color: #adaba5;
    margin-right: 10px;
    &.active,
    &:hover {
      color: chocolate;
    }
  }
}
.notices {
  color: chocolate;
  text-align: center;
}
*/
.cont {
  max-width: 600px;
  min-width: 320px;
  margin: 0 auto;
}
#buttonrow {
  max-width: 600px;
  min-width: 320px;
  margin: 0 auto;
}
</style>
